export default () => ({
  '-2': '13px',
  '-1': '14px',
  '0': '0px',
  '1': '16px',
  '2': '20px',
  '3': '24px',
  '4': '30px',
  '5': '36px',
  '6': '48px',
});
